module.exports = __webpack_public_path__ + "static/media/about.d40d182a.svg";